import { render, staticRenderFns } from "./AppAuth.vue?vue&type=template&id=70bb9392"
import script from "./AppAuth.vue?vue&type=script&lang=js"
export * from "./AppAuth.vue?vue&type=script&lang=js"
import style0 from "./AppAuth.vue?vue&type=style&index=0&id=70bb9392&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports